import { colors } from '@creditsights/styleguide-web';
import { Period } from './RiskSummary.logic';

export const Volatility = ['High', 'Medium', 'Low'];

export const cqsColorConfig: Record<Period, string> = {
  [Period.VERY_LOW]: colors.high100,
  [Period.LOW]: colors.high50,
  [Period.MODERATE]: colors.moderate,
  [Period.HIGH]: colors.low50,
  [Period.VERY_HIGH]: colors.low100,
  [Period.NOT_AVAILABLE]: colors.tertiary300,
};
